var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { StyledButton } from "./styled";
import { Icon } from "../icon";
import { LoaderIcon } from "../icon/components";
import Flex from "../templates/flex";
export var Button = forwardRef(function (_a, ref) {
    var label = _a.label, icon = _a.icon, flavour = _a.flavour, isLoading = _a.isLoading, loadingLabel = _a.loadingLabel, onClick = _a.onClick, _b = _a.textTransform, textTransform = _b === void 0 ? "firstLetter" : _b, rest = __rest(_a, ["label", "icon", "flavour", "isLoading", "loadingLabel", "onClick", "textTransform"]);
    return (React.createElement(StyledButton, __assign({ flavour: flavour, textTransform: textTransform, hasLabel: !!label, hasIcon: !!icon || isLoading, onClick: isLoading ? undefined : onClick, ref: ref }, rest),
        isLoading && React.createElement(LoaderIcon, { className: "button-icon" }),
        icon && !isLoading && (React.createElement(Flex, { justifyContent: "center", alignItems: "center", width: "auto", height: "100%" },
            React.createElement(Icon, { className: "button-icon", title: icon, name: icon }))),
        label && React.createElement("span", null, (isLoading && loadingLabel) || label)));
});
Button.defaultProps = {
    onClick: function () { },
    icon: null,
};
